/**
 * getCurrentUser module
 * Retrieves the current user from local storage
 */
import { CognitoUserPool } from 'amazon-cognito-identity-js';
import schoolConstants from '../constants/schoolConstants';

function getCurrentUser() {
  if (!localStorage.zmailSchoolName) return null;

  if (window.redirectBool)
    return {
      username: localStorage.zmailUsername,
    };

  // Get Current User from CognitoUserPool
  var schoolName = localStorage.zmailSchoolName;
  var params = {
    UserPoolId: schoolConstants[schoolName].UserPoolId,
    ClientId: schoolConstants[schoolName].ClientId,
  };
  var userPool = new CognitoUserPool(params);
  var cognitoUser = userPool.getCurrentUser();

  if (cognitoUser != null) {
    cognitoUser.getSession(function (err, session) {
      if (err) throw err;
    });
  }

  return cognitoUser;
}

export default getCurrentUser;



// WEBPACK FOOTER //
// ./src/authentication/getCurrentUser.js